import ReactRailsUJS from 'react_ujs';
import "core-js/stable";
import "regenerator-runtime/runtime";
import "focus-visible";

ReactRailsUJS.useContext(require.context('components', true));
